// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

const ROOTS_AUTH = '/auth';
const ROOTS_DASHBOARD = '/dashboard';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
  loginUnprotected: path(ROOTS_AUTH, '/login-unprotected'),
  register: path(ROOTS_AUTH, '/register'),
  registerUnprotected: path(ROOTS_AUTH, '/register-unprotected'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
  verify: path(ROOTS_AUTH, '/verify'),
};

export const PATH_PAGE = {
  home: '/',
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/plan/pricing',
  reporting: '/reporting',
  blog: '/blog',
  payment: '/payment',
  about: '/page/about-us',
  contact: '/contact-us',
  login: '/dashboard/app',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  assetmgmt: '/page/asset-management',
  locmgmt: '/page/location-management',
  facimgmt: '/page/facilities-management',
  tltlkitmgmt: '/page/tools-toolkits-management',
  hwswmgmt: '/page/hardware-software-requirements',
  fleetmgmt: '/page/fleet-management',
  inventmgmt: '/page/inventory-management',
  toolmgmt: '/page/toolkits-management',
  resrcmgmt: '/page/resource-management',
  residensmgmt: '/page/residential-asset-management',
  livestockmgmt: '/page/livestock-management',
  components: '/components',
  catalog: {
    root: '/catalog/company',
  },
  powerbireports: {
    equipmentreport: '/powerbireports/equipmentreport',
    resourcereport: '/powerbireports/resourcereport',
  },
  resource: {
    root: '/resource',
  },
  material: {
    root: '/material',
  },
  vendor: {
    root: '/vendor',
  },
  fleet: {
    root: '/fleet',
  },
  tag: {
    root: '/scan/equipment-tag-scan',
    fuel: '/scan/equipment-tag-scan/fuel',
    equipment_transfers: '/scan/equipment-tag-scan/equipment_transfers',
    equipment_usages: '/scan/equipment-tag-scan/equipment_usages',
    odos: '/scan/equipment-tag-scan/odos',
    meter_readings: '/scan/equipment-tag-scan/meter_readings',
    change_location: '/scan/equipment-tag-scan/change_location',
    change_tag: '/scan/equipment-tag-scan/change_tag',
  },
  job_tag_scan: {
    root: '/scan/job-tag-scan',
    change_location: '/scan/job-tag-scan/change_location',
    add_time_card: '/scan/job-tag-scan/add_time_card',
    tool_details: '/scan/job-tag-scan/tool_details',
    add_time_card_form: '/scan/job-tag-scan/add_time_card/form',
  },
  training: {
    root: '/scan/training-class/',
    reschedule: '/scan/training-class/reschedule/',
    cancel: '/scan/training-class/cancel/',
    accept: '/scan/training-class/accept/',
  },
  toolkit: {
    root: '/scan/toolkit-scan/',
    changeLocation: '/scan/toolkit-scan/change-location/',
    changeTag: '/scan/toolkit-scan/change-tag/',
    kit: {
      root: '/scan/kit-tag-scan/',
      kitItem: {
        root: '/scan/kit-item-tag-scan/',
        changeQuantity: '/scan/kit-item-tag-scan/change-item-quantity/',
        changeLocation: '/scan/kit-item-tag-scan/change-location/',
        changeTookit: '/scan/kit-item-tag-scan/change-item-toolkit/',
      },
    },
  },
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    equipmentApp: path(ROOTS_DASHBOARD, '/equipmentDashboard'),
    resourceApp: path(ROOTS_DASHBOARD, '/resourceDashboard'),
    jobApp: path(ROOTS_DASHBOARD, '/jobDashboard'),
    ticketApp: path(ROOTS_DASHBOARD, '/ticketDashboard'),
  },
  powerbireports: {
    equipmentreport: path(ROOTS_DASHBOARD, '/powerbireports/equipmentreport'),
    resourcereport: path(ROOTS_DASHBOARD, '/powerbireports/resourcereport'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/user'),
    profile: path(ROOTS_DASHBOARD, '/user/profile'),
    cards: path(ROOTS_DASHBOARD, '/user/cards'),
    users: path(ROOTS_DASHBOARD, '/user/users'),
    activity_logs: path(ROOTS_DASHBOARD, '/user/activity_logs'),
    user_login_histories: path(ROOTS_DASHBOARD, '/user/user_login_histories'),
    newUser: path(ROOTS_DASHBOARD, '/user/users/form/new'),
    editById: path(ROOTS_DASHBOARD, `/user/reece-chung/edit`),
    account: path(ROOTS_DASHBOARD, '/user/account'),
    roles: path(ROOTS_DASHBOARD, '/user/roles'),
    user_statuses: path(ROOTS_DASHBOARD, '/user/user_statuses'),
    promo_code: path(ROOTS_DASHBOARD, '/user/promo_code'),
    newRole: path(ROOTS_DASHBOARD, '/user/roles/form/new'),
    payment_methods: path(ROOTS_DASHBOARD, '/user/payment_methods'),
    plan_subscription_statuses: path(ROOTS_DASHBOARD, '/user/plan_subscription_statuses'),
    plan_master: path(ROOTS_DASHBOARD, '/user/plan_master'),
    plan_subscriptions: path(ROOTS_DASHBOARD, '/user/plan_subscriptions'),
    transactions: path(ROOTS_DASHBOARD, '/user/transactions'),
  },

  location: {
    root: path(ROOTS_DASHBOARD, '/location'),
    countries: path(ROOTS_DASHBOARD, '/location/countries'),
    states: path(ROOTS_DASHBOARD, '/location/states'),
    cities: path(ROOTS_DASHBOARD, '/location/cities'),
    location_statuses: path(ROOTS_DASHBOARD, '/location/location_statuses'),
    location: path(ROOTS_DASHBOARD, '/location/master'),
    location_tag: path(ROOTS_DASHBOARD, '/location/location_tag'),
    locationLiveTag: path(ROOTS_DASHBOARD, '/location/location-live-position/location-tag'),
    tax_codes: path(ROOTS_DASHBOARD, '/location/tax_codes'),
    location_tag_history: path(ROOTS_DASHBOARD, '/location/location_tag_history'),
    location_comment_logs: path(ROOTS_DASHBOARD, '/location/location_comment_logs'),
  },

  catalog: {
    root: path(ROOTS_DASHBOARD, '/catalog'),
    faq_groups: path(ROOTS_DASHBOARD, '/catalog/faq_groups'),
    faqs: path(ROOTS_DASHBOARD, '/catalog/faqs'),
    contents: path(ROOTS_DASHBOARD, '/catalog/contents'),
    enquiries: path(ROOTS_DASHBOARD, '/catalog/enquiries'),
    team: path(ROOTS_DASHBOARD, '/catalog/team'),
  },

  document: {
    root: path(ROOTS_DASHBOARD, '/document'),
    documents: path(ROOTS_DASHBOARD, '/document/documents'),
    document_types: path(ROOTS_DASHBOARD, '/document/document_types'),
    document_tags: path(ROOTS_DASHBOARD, '/document/document_tags'),
    documentLiveTag: path(ROOTS_DASHBOARD, '/document/document-live-position/document-tag'),
    document_tag_history: path(ROOTS_DASHBOARD, '/document/document_tag_history'),
    document_jobs: path(ROOTS_DASHBOARD, '/document/document_jobs'),
    document_comment_logs: path(ROOTS_DASHBOARD, '/document/document_comment_logs'),
    resource_documents: path(ROOTS_DASHBOARD, '/resource/assign/resource_documents'),
  },

  support: {
    root: path(ROOTS_DASHBOARD, '/support'),
    support_tickets: path(ROOTS_DASHBOARD, '/support/support_tickets'),
  },

  tag: {
    root: path(ROOTS_DASHBOARD, '/tag'),
    tag_categories: path(ROOTS_DASHBOARD, '/tag/tag_categories'),
    tag_type: path(ROOTS_DASHBOARD, '/tag/tag_type'),
    tag_statuses: path(ROOTS_DASHBOARD, '/tag/tag_statuses'),
    tags: path(ROOTS_DASHBOARD, '/tag/tags'),
    tag_scan: path(ROOTS_DASHBOARD, '/tag/tag_scan'),
    tagTrack: path(ROOTS_DASHBOARD, '/tag/tag-track'),
    livePosition: {
      root: path(ROOTS_DASHBOARD, '/tag/live-position'),
      all: path(ROOTS_DASHBOARD, '/tag/live-position/all'),
      tag: path(ROOTS_DASHBOARD, '/tag/live-position/tag'),
      equipmentTag: path(ROOTS_DASHBOARD, '/tag/live-position/equipment-tag'),
      fleetTag: path(ROOTS_DASHBOARD, '/tag/live-position/fleet-tag'),
      jobTag: path(ROOTS_DASHBOARD, '/tag/live-position/job-tag'),
      documentTag: path(ROOTS_DASHBOARD, '/tag/live-position/document-tag'),
      locationTag: path(ROOTS_DASHBOARD, '/tag/live-position/location-tag'),
      inventoryTag: path(ROOTS_DASHBOARD, '/tag/live-position/inventory-tag'),
      resourceTag: path(ROOTS_DASHBOARD, '/tag/live-position/resource-tag'),
      toolkitTag: path(ROOTS_DASHBOARD, '/tag/live-position/toolkit-tag'),
    },
  },

  asset: {
    root: path(ROOTS_DASHBOARD, '/asset'),

    material_categories: path(ROOTS_DASHBOARD, '/asset/material_categories'),
    material_groups: path(ROOTS_DASHBOARD, '/asset/material_groups'),
    material_types: path(ROOTS_DASHBOARD, '/asset/material_types'),
    materials: path(ROOTS_DASHBOARD, '/asset/materials'),
    material_scans: path(ROOTS_DASHBOARD, '/asset/material_scans'),
    material_jobs: path(ROOTS_DASHBOARD, '/asset/material_jobs'),

    vendor_groups: path(ROOTS_DASHBOARD, '/asset/vendor_groups'),
    vendor_types: path(ROOTS_DASHBOARD, '/asset/vendor_types'),
    vendors: path(ROOTS_DASHBOARD, '/asset/vendors'),

    inventory_materials: path(ROOTS_DASHBOARD, '/asset/inventory_materials'),
    inventory_material_tracks: path(ROOTS_DASHBOARD, '/asset/inventory_material_tracks'),
    inventory_tags: path(ROOTS_DASHBOARD, '/asset/inventory_tags'),
    inventoryLiveTag: path(ROOTS_DASHBOARD, '/asset/inventory-live-position/inventory-tag'),
    inventory_tag_history: path(ROOTS_DASHBOARD, '/asset/inventory_tag_history'),
    inventory_comment_logs: path(ROOTS_DASHBOARD, '/asset/inventory_comment_logs'),
  },

  company: {
    root: path(ROOTS_DASHBOARD, '/company'),
    company_statuses: path(ROOTS_DASHBOARD, '/company/company_statuses'),
    company_scans: path(ROOTS_DASHBOARD, '/company/company_scans'),
    company_plan: path(ROOTS_DASHBOARD, '/company/company_plan'),
    company_address: path(ROOTS_DASHBOARD, '/company/company_address'),
    companies: path(ROOTS_DASHBOARD, '/company/companies'),
    company_employees: path(ROOTS_DASHBOARD, '/company/company_employees'),
    email_content: path(ROOTS_DASHBOARD, '/company/email_content'),
    company_notifications: path(ROOTS_DASHBOARD, '/company/company_notifications'),
    departments: path(ROOTS_DASHBOARD, '/company/departments'),
    units_of_measures: path(ROOTS_DASHBOARD, '/company/units_of_measures'),
    employee_attendance: path(ROOTS_DASHBOARD, '/company/employee_attendance'),
    manufacturers: path(ROOTS_DASHBOARD, '/company/manufacturers'),
    qr_setting: path(ROOTS_DASHBOARD, '/company/qr_setting'),
    company_settings: {
      root: path(ROOTS_DASHBOARD, '/company/company_settings'),
    },
    azuga: {
      root: path(ROOTS_DASHBOARD, '/company/azuga'),
      setting: path(ROOTS_DASHBOARD, '/company/azuga/setting'),
    },
    attachment: {
      root: path(ROOTS_DASHBOARD, '/attachment'),
      attachment_types: path(ROOTS_DASHBOARD, '/company/attachment/attachment_types'),
      attachment_extension_types: path(ROOTS_DASHBOARD, '/company/attachment/attachment_extension_types'),
      attachments: path(ROOTS_DASHBOARD, '/company/attachment/attachments'),
      attachment_revision: path(ROOTS_DASHBOARD, '/company/attachment/attachment_revision'),
      attachment_status: path(ROOTS_DASHBOARD, '/company/attachment/attachment_status'),
    },
  },

  equipments: {
    root: path(ROOTS_DASHBOARD, '/equipments'),
    equipment_categories: path(ROOTS_DASHBOARD, '/equipments/equipment_categories'),
    equipment_statuses: path(ROOTS_DASHBOARD, '/equipments/equipment_statuses'),
    master: path(ROOTS_DASHBOARD, '/equipments/master'),
    equipment_material_groups: path(ROOTS_DASHBOARD, '/equipments/equipment_material_groups'),
    equipment_fuels: path(ROOTS_DASHBOARD, '/equipments/reading/equipment_fuels'), //only display on admin panel not for superadmin
    equipment_tags: path(ROOTS_DASHBOARD, '/equipments/equipment_tags'),
    equipment_jobs: path(ROOTS_DASHBOARD, '/equipments/equipment_jobs'),
    equipmentLiveTag: path(ROOTS_DASHBOARD, '/equipments/equipment-live-position/equipment-tag'),
    transfer_types: path(ROOTS_DASHBOARD, '/equipments/transfer_types'),
    equipment_tag_history: path(ROOTS_DASHBOARD, '/equipments/equipment_tag_history'),
    rev_codes: path(ROOTS_DASHBOARD, '/equipments/rev_codes'),
    reading: {
      root: path(ROOTS_DASHBOARD, '/equipments/reading'),
      equipment_odos: path(ROOTS_DASHBOARD, '/equipments/reading/equipment_odos'),
      equipment_fuels: path(ROOTS_DASHBOARD, '/equipments/reading/equipment_fuels'),
      em_fuel_usages: path(ROOTS_DASHBOARD, '/equipments/reading/em_fuel_usages'),
      em_meter_readings: path(ROOTS_DASHBOARD, '/equipments/reading/em_meter_readings'),
      em_transfers: path(ROOTS_DASHBOARD, '/equipments/reading/em_transfers'),
      em_usage_charges: path(ROOTS_DASHBOARD, '/equipments/reading/em_usage_charges'),
      reading_master: path(ROOTS_DASHBOARD, '/equipments/reading/reading_master'),
    },
    equipment_comment_logs: path(ROOTS_DASHBOARD, '/equipments/equipment_comment_logs'),
  },

  fleets: {
    root: path(ROOTS_DASHBOARD, '/fleets'),
    fleet_categories: path(ROOTS_DASHBOARD, '/fleets/fleet_categories'),
    fleet_types: path(ROOTS_DASHBOARD, '/fleets/fleet_types'),
    fleet_statuses: path(ROOTS_DASHBOARD, '/fleets/fleet_statuses'),
    fleets_master: path(ROOTS_DASHBOARD, '/fleets/fleets_master'),
    fleet_tags: path(ROOTS_DASHBOARD, '/fleets/fleet_tags'),
    fleet_tag_history: path(ROOTS_DASHBOARD, '/fleets/fleet_tag_history'),
    fleetLiveTag: path(ROOTS_DASHBOARD, '/fleets/fleet-live-position/fleet-tag'),
    reading: {
      root: path(ROOTS_DASHBOARD, '/fleets/reading'),
      fleet_fuels: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_fuels'),
      reading_master: path(ROOTS_DASHBOARD, '/fleets/reading/reading_master'),
      fleet_fuel_usages: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_fuel_usages'),
      fleet_meter_readings: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_meter_readings'),
      fleet_meter_readings_history: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_meter_readings_history'),
      fleet_odos: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_odos'),
      fleet_transfers: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_transfers'),
      fleet_usage_charges: path(ROOTS_DASHBOARD, '/fleets/reading/fleet_usage_charges'),
    },
    azuga: {
      root: path(ROOTS_DASHBOARD, '/fleets/azuga'),
      liveLocation: path(ROOTS_DASHBOARD, '/fleets/azuga/live-location'),
      logs: path(ROOTS_DASHBOARD, '/fleets/azuga/logs'),
    },
    fleet_comment_logs: path(ROOTS_DASHBOARD, '/fleets/fleet_comment_logs'),
  },

  toolkit: {
    root: path(ROOTS_DASHBOARD, '/toolkit'),
    toolkits: path(ROOTS_DASHBOARD, '/toolkit/toolkits'),
    toolkit_tags: path(ROOTS_DASHBOARD, '/toolkit/toolkit_tags'),
    toolkitLiveTag: path(ROOTS_DASHBOARD, '/toolkit/toolkit-live-position/toolkit-tag'),
    toolkit_statuses: path(ROOTS_DASHBOARD, '/toolkit/toolkit_statuses'),
    kit_items: path(ROOTS_DASHBOARD, '/toolkit/kit_items'),
    kit_item_tags: path(ROOTS_DASHBOARD, '/toolkit/kit_item_tags'),
    kit_item_statuses: path(ROOTS_DASHBOARD, '/toolkit/kit_item_statuses'),
    kit_item_jobs: path(ROOTS_DASHBOARD, '/toolkit/kit_item_jobs'),
    kit_item_tag_history: path(ROOTS_DASHBOARD, '/toolkit/kit_item_tag_history'),
    kit_tag_history: path(ROOTS_DASHBOARD, '/toolkit/kit_tag_history'),
    toolkit_tag_history: path(ROOTS_DASHBOARD, '/toolkit/toolkit_tag_history'),
    tools_detail: path(ROOTS_DASHBOARD, '/toolkit/tools_detail'),
    category: path(ROOTS_DASHBOARD, '/toolkit/category'),
    toolkit_comment_logs: path(ROOTS_DASHBOARD, '/toolkit/toolkit_comment_logs'),
    kititem_comment_logs: path(ROOTS_DASHBOARD, '/toolkit/kititem_comment_logs'),
    reading: {
      root: path(ROOTS_DASHBOARD, '/toolkit/reading'),
      reading_master: path(ROOTS_DASHBOARD, '/toolkit/reading/reading_master'),
      toolkit_transfers: path(ROOTS_DASHBOARD, '/toolkit/reading/toolkit_transfers'),
      toolkit_fuel_usages: path(ROOTS_DASHBOARD, '/toolkit/reading/toolkit_fuel_usages'),
      toolkit_usage_charges: path(ROOTS_DASHBOARD, '/toolkit/reading/toolkit_usage_charges'),
    },
  },
  job: {
    root: path(ROOTS_DASHBOARD, '/job'),
    job_costs: path(ROOTS_DASHBOARD, '/job/job_costs'),
    batches: path(ROOTS_DASHBOARD, '/job/batches'),
    payrolls: path(ROOTS_DASHBOARD, '/job/payrolls'),
    phase_groups: path(ROOTS_DASHBOARD, '/job/phase_groups'),
    field_tickets: path(ROOTS_DASHBOARD, '/job/field_tickets'),
    job_master: path(ROOTS_DASHBOARD, '/job/job_master'),
    job_type: path(ROOTS_DASHBOARD, '/job/job_type'),
    job_phases: path(ROOTS_DASHBOARD, '/job/job_phases'),
    earn_codes: path(ROOTS_DASHBOARD, '/job/earn_codes'),
    job_statuses: path(ROOTS_DASHBOARD, '/job/job_statuses'),
    job_time_card: path(ROOTS_DASHBOARD, '/job/job_time_card'),
    job_tag: path(ROOTS_DASHBOARD, '/job/job_tag'),
    jobLiveTag: path(ROOTS_DASHBOARD, '/job/job-live-position/job-tag'),
    job_tag_history: path(ROOTS_DASHBOARD, '/job/job-tag-history'),
    crew: {
      root: path(ROOTS_DASHBOARD, '/job/crew'),
      crews: path(ROOTS_DASHBOARD, '/job/crew/crews'),
      crewUser: path(ROOTS_DASHBOARD, '/job/crew/crew_users'),
      workCard: path(ROOTS_DASHBOARD, '/job/crew/work_card'),
      work_card_history: path(ROOTS_DASHBOARD, '/job/crew/work_history'),
      equipmentWorkCard: path(ROOTS_DASHBOARD, '/job/crew/equipment_work_card'),
      equipmentWorkCardHistory: path(ROOTS_DASHBOARD, '/job/crew/equipment_work_history'),
      workCardShift: path(ROOTS_DASHBOARD, '/job/crew/work_shift_card'),
      payPeriod: path(ROOTS_DASHBOARD, '/job/crew/pay_period'),
    },
    job_comment_logs: path(ROOTS_DASHBOARD, '/job/job_comment_logs'),
  },

  resource: {
    root: path(ROOTS_DASHBOARD, '/resource'),
    resource_groups: path(ROOTS_DASHBOARD, '/resource/resource_groups'),
    resource_tag_history: path(ROOTS_DASHBOARD, '/resource/resource_tag_history'),
    resource_statuses: path(ROOTS_DASHBOARD, '/resource/resource_statuses'),
    resources: path(ROOTS_DASHBOARD, '/resource/resources'),
    resource_tags: path(ROOTS_DASHBOARD, '/resource/resource_tags'),
    resourceLiveTag: path(ROOTS_DASHBOARD, '/resource/resource-live-position/resource-tag'),
    resource_craft_class: path(ROOTS_DASHBOARD, '/resource/resource_craft_class'),
    training_class: {
      root: path(ROOTS_DASHBOARD, '/resource/training_class'),
      training_calender: path(ROOTS_DASHBOARD, '/resource/training_class/calender'),
      training_classes: path(ROOTS_DASHBOARD, '/resource/training_class/training_classes'),
      training_class_scans: path(ROOTS_DASHBOARD, '/resource/training_class/training_class_scans'),
      training_class_invites: path(ROOTS_DASHBOARD, '/resource/training_class/training_class_invites'),

      skill_types: path(ROOTS_DASHBOARD, '/resource/training_class/skill_types'),
      skills: path(ROOTS_DASHBOARD, '/resource/training_class/skills'),
    },
    assign: {
      root: path(ROOTS_DASHBOARD, '/resource/assign'),
      resource_documents: path(ROOTS_DASHBOARD, '/resource/assign/resource_documents'),
      resource_equipments: path(ROOTS_DASHBOARD, '/resource/assign/resource_equipments'),
      resource_jobs: path(ROOTS_DASHBOARD, '/resource/assign/resource_jobs'),
      resource_kit_items: path(ROOTS_DASHBOARD, '/resource/assign/resource_kit_items'),
      resource_materials: path(ROOTS_DASHBOARD, '/resource/assign/resource_materials'),
      resource_toolkits: path(ROOTS_DASHBOARD, '/resource/assign/resource_toolkits'),
    },
    resource_comment_logs: path(ROOTS_DASHBOARD, '/resource/resource_comment_logs'),
  },

  blog: {
    root: path(ROOTS_DASHBOARD, '/blog'),
    posts: path(ROOTS_DASHBOARD, '/blog/posts'),
    // post: path(ROOTS_DASHBOARD, '/blog/post/:title'),
    postById: path(ROOTS_DASHBOARD, '/blog/post/apply-these-7-secret-techniques-to-improve-event'),
    newPost: path(ROOTS_DASHBOARD, '/blog/new-post'),
    category: path(ROOTS_DASHBOARD, '/blog/category'),
    post: path(ROOTS_DASHBOARD, '/blog/post'),
  },

  report: {
    root: path(ROOTS_DASHBOARD, '/report'),
    equipment: {
      root: path(ROOTS_DASHBOARD, '/report/equipment'),
      list: path(ROOTS_DASHBOARD, '/report/equipment/list'),
      summary: path(ROOTS_DASHBOARD, '/report/equipment/summary'),
    },
    resource: {
      root: path(ROOTS_DASHBOARD, '/report/resource'),
      list: path(ROOTS_DASHBOARD, '/report/resource/list'),
      summary: path(ROOTS_DASHBOARD, '/report/resource/summary'),
    },
    job: {
      root: path(ROOTS_DASHBOARD, '/report/job'),
      list: path(ROOTS_DASHBOARD, '/report/job/list'),
      summary: path(ROOTS_DASHBOARD, '/report/job/summary'),
    },

    ticket: {
      root: path(ROOTS_DASHBOARD, '/report/ticket'),
      list: path(ROOTS_DASHBOARD, '/report/ticket/list'),
    },
    custom_report: {
      root: path(ROOTS_DASHBOARD, '/report/custom'),
      list: path(ROOTS_DASHBOARD, '/report/custom/list'),
      custom: path(ROOTS_DASHBOARD, '/report/custom/'),
    },
  },
  ticket: {
    calender: path(ROOTS_DASHBOARD, '/ticket/calender'),
    tickets: path(ROOTS_DASHBOARD, '/ticket/tickets'),
    trips: path(ROOTS_DASHBOARD, '/ticket/trips'),
    options: {
      root: path(ROOTS_DASHBOARD, '/ticket/options'),
      customer: path(ROOTS_DASHBOARD, '/ticket/options/customer'),
      dumpster: path(ROOTS_DASHBOARD, '/ticket/options/dumpster'),
      issue: path(ROOTS_DASHBOARD, '/ticket/options/issue'),
      tripType: path(ROOTS_DASHBOARD, '/ticket/options/trip_type'),
      wasteType: path(ROOTS_DASHBOARD, '/ticket/options/waste_type'),
      itemType: path(ROOTS_DASHBOARD, '/ticket/options/item_type'),
    },
    logs: {
      root: path(ROOTS_DASHBOARD, '/ticket/logs'),
      ticketLogs: path(ROOTS_DASHBOARD, '/ticket/logs/ticket_logs'),
      viewticketLogsList: path(ROOTS_DASHBOARD, '/ticket/logs/view_ticket_logs'),
    },
    reports: path(ROOTS_DASHBOARD, '/ticket/reports'),
    livePosition: path(ROOTS_DASHBOARD, '/ticket/live-position'),
    surchargeGroup: path(ROOTS_DASHBOARD, '/ticket/surcharge_groups'),
    surcharge: path(ROOTS_DASHBOARD, '/ticket/surcharges'),

    // scan: path(ROOTS_DASHBOARD, '/employee/ticket/')
  },

  settings: {
    root: path(ROOTS_DASHBOARD, '/settings'),
  },
  profileUpdate: {
    root: path(ROOTS_DASHBOARD, '/profileUpdate'),
  },
};

export const PATH_DOCS = 'https://docs-minimals.vercel.app/introduction';
